export default () =>
  import(/* webpackChunkName: 'coffee/activities/fission/dice' */ './Dice');
